import React from 'react'
import { DISPATCH_TICKET_STATUSES, DISPATCH_TICKET_TYPES } from 'utils/constants'
import { Radio, Link } from '@mui/material_modern'
import Tooltip from 'components/generic/tooltip/index'
/**
 *
 * @param selectedRowId {string[]} - array of selected row ids
 * @return {Object[]} - array of column objects
 */
export const getColumns = selectedRowId => [
  {
    field: 'radioOption',
    headerName: '',
    sortable: false,
    flex: 0.5,
    renderCell: params => (
      <Radio checked={selectedRowId.length > 0 && selectedRowId[0] === params.id} value={params.id} />
    ),
  },
  {
    field: 'id',
    headerName: 'Ticket #',
    flex: 0.6,
    renderCell: params => (
      <Link
        href={params.row.ticketLink}
        target="_blank"
        rel="noopener noreferrer"
        sx={theme => ({
          color: theme.palette.primary.main,
          textDecoration: 'none',
          fontWeight: 'bold',
          '&:hover': {
            textDecoration: 'underline',
            color: theme.palette.primary.dark,
          },
        })}
      >
        {params.row.ticketId}
      </Link>
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    renderCell: params => {
      const dtStatusString = params.formattedValue
      return DISPATCH_TICKET_STATUSES[dtStatusString]?.name
    },
    flex: 1,
  },
  {
    field: 'type',
    headerName: 'Type',
    renderCell: params => {
      const dtTypeString = params.formattedValue
      return DISPATCH_TICKET_TYPES[dtTypeString]?.name
    },
    flex: 1,
  },
  {
    field: 'driver',
    headerName: 'Driver',
    flex: 1,
  },
  {
    field: 'assetNames',
    headerName: 'Asset Name',
    flex: 1,
    renderCell: params => {
      const { assetNames } = params.row
      if (assetNames.length > 1) {
        return (
          <Tooltip content={assetNames?.join(', ')}>
            <>Multiple</>
          </Tooltip>
        )
      } else {
        return <>{assetNames[0] || ''}</>
      }
    },
  },
  {
    field: 'customer',
    headerName: 'Customer',
    flex: 1,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1,
  },
  {
    field: 'scheduled',
    headerName: 'Scheduled',
    flex: 1,
  },
]

export const getActionButtons = (setShowIbtCreateModal, onHideModal, canSubmit) => [
  {
    id: 'select-dispatch-to-ibt-button',
    text: 'Select',
    type: 'submit',
    variant: 'contained',
    disabled: !canSubmit,
    onClick: () => setShowIbtCreateModal(true),
  },
  {
    id: 'exit-dispatch-to-ibt-button',
    text: 'Cancel',
    onClick: () => onHideModal(),
  },
]
